/**
 * Centraliza claves de sessionStorage B2B y limpia estado de Comercial al cerrar sesión.
 */
(function (global) {
  'use strict';

  /** Estado de impersonación / pedido en nombre de cliente (solo Comerciales). */
  var COMMERCIAL_KEYS = [
    'selectedCustomer',
    'selectedCustomerName',
    'selectorElementId',
    'selectorData',
    'selectorOrderData',
    'cartRecovered',
    'cartNoteRecovered',
    'createOrderV3PendingPoll',
    'createOrderV2PendingPoll',
    'draftOrderId',
    'draftOrder',
    'draftOrderOwner',
    'draftOrderCapsuleTax',
    'draftOrderCapsule',
    'preorderPageUrl',
    'gobikCommercialClientGateHomeDismissed',
  ];

  var CACHE_PREFIXES = [
    'linkedClientsV2_cache_',
    'linkedClientsV2_timestamp_',
    'draftOrders_cache_',
    'draftOrders_timestamp_',
  ];

  /**
   * Nota de usuario sin tokens empaquetados (SHIPPING_*, TAXES_*). Misma regla que gobik-integration.
   */
  function stripEncodedNoteSegments(note) {
    if (note == null || note === '') return '';
    return String(note)
      .split(',')
      .map(function (s) {
        return s.trim();
      })
      .filter(function (segment) {
        if (!segment) return false;
        var upper = segment.toUpperCase();
        return (
          upper.indexOf('SHIPPING_PRICE_') === -1 &&
          upper.indexOf('SHIPPING_TITLE_') === -1 &&
          upper.indexOf('TAXES_') !== 0
        );
      })
      .join(',');
  }

  function setCartNoteRecovered(note) {
    var clean = stripEncodedNoteSegments(note);
    try {
      if (clean) {
        sessionStorage.setItem('cartNoteRecovered', clean);
      }
      /* Sin nota en el draft: no borrar cartNoteRecovered existente. */
    } catch (e) {
      /* ignore */
    }
  }

  function clearCartNoteRecovered() {
    try {
      sessionStorage.removeItem('cartNoteRecovered');
    } catch (e) {
      /* ignore */
    }
  }

  /** IDs y metadatos de borrador (no incluye cartRecovered ni cartNoteRecovered). */
  var DRAFT_ORDER_ID_KEYS = [
    'draftOrderId',
    'draftOrder',
    'draftOrderOwner',
    'draftOrderCapsuleTax',
    'draftOrderCapsule',
  ];

  var DRAFT_ORDER_KEYS = DRAFT_ORDER_ID_KEYS.concat(['cartRecovered', 'cartNoteRecovered']);

  /** Estado residual tras editar/confirmar un borrador (nota, IDs, cliente impersonado). */
  var ORDER_WORKFLOW_KEYS = DRAFT_ORDER_KEYS.concat([
    'selectedCustomer',
    'selectedCustomerName',
    'selectorElementId',
    'selectorOrderData',
    'createOrderV3PendingPoll',
    'createOrderV2PendingPoll',
  ]);

  function clearCartNoteFields() {
    try {
      ['CartDrawer-Note', 'CartNote', 'cart-note'].forEach(function (id) {
        var el = global.document.getElementById(id);
        if (el) el.value = '';
      });
    } catch (e) {
      /* ignore */
    }
  }

  function clearDraftOrderIdKeys() {
    DRAFT_ORDER_ID_KEYS.forEach(function (key) {
      try {
        sessionStorage.removeItem(key);
      } catch (e) {
        /* ignore */
      }
    });
  }

  /** Limpieza completa de borrador + recuperación de carrito (p. ej. pedido nuevo explícito). */
  function clearDraftOrderContext() {
    DRAFT_ORDER_KEYS.forEach(function (key) {
      try {
        sessionStorage.removeItem(key);
      } catch (e) {
        /* ignore */
      }
    });
    clearCartNoteFields();
  }

  /**
   * Tras confirmar/finalizar un pedido o abandonar edición de borrador:
   * quita draftOrderId, nota recuperada, cliente seleccionado, etc.
   */
  function clearOrderWorkflowSession() {
    ORDER_WORKFLOW_KEYS.forEach(function (key) {
      try {
        sessionStorage.removeItem(key);
      } catch (e) {
        /* ignore */
      }
    });
    clearCartNoteFields();
  }

  /**
   * Tras vaciar el carrito Shopify: quitar draftOrderId, etc.
   * Nunca toca cartNoteRecovered (se conserva para checkout tras editar borrador).
   * No aplica si hay cartRecovered (recuperación de draft en curso).
   */
  function onCartCleared() {
    try {
      if (sessionStorage.getItem('cartRecovered')) return;
    } catch (e) {
      return;
    }
    clearDraftOrderIdKeys();
  }

  function patchCartClearHooks() {
    if (!global.fetch || global.__gobikCartClearPatched) return;
    global.__gobikCartClearPatched = true;
    var nativeFetch = global.fetch.bind(global);
    global.fetch = function (input, init) {
      var url = '';
      if (typeof input === 'string') {
        url = input;
      } else if (input && input.url) {
        url = input.url;
      }
      return nativeFetch(input, init).then(function (response) {
        if (response && response.ok && /\/cart\/clear\.js(\?|$)/.test(url)) {
          onCartCleared();
        }
        return response;
      });
    };
  }

  function patchJQueryCartClear() {
    if (!global.jQuery || global.__gobikJqueryCartClearPatched) return;
    global.__gobikJqueryCartClearPatched = true;
    global.jQuery(document).ajaxSuccess(function (_event, xhr, settings) {
      if (!settings || !settings.url || !xhr) return;
      if (xhr.status !== 200 && xhr.status !== 0) return;
      if (/\/cart\/clear\.js(\?|$)/.test(String(settings.url))) {
        onCartCleared();
      }
    });
  }

  patchCartClearHooks();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchJQueryCartClear);
  } else {
    patchJQueryCartClear();
  }

  function clearCommercialSession() {
    COMMERCIAL_KEYS.forEach(function (key) {
      try {
        sessionStorage.removeItem(key);
      } catch (e) {
        /* ignore */
      }
    });
    clearCartNoteFields();

    try {
      Object.keys(sessionStorage).forEach(function (key) {
        if (CACHE_PREFIXES.some(function (prefix) { return key.indexOf(prefix) === 0; })) {
          sessionStorage.removeItem(key);
        }
      });
    } catch (e) {
      console.error('[B2BSessionStorage] Error clearing prefixed cache keys:', e);
    }

    if (global.LinkedClientsCache && typeof global.LinkedClientsCache.clearAllCache === 'function') {
      global.LinkedClientsCache.clearAllCache();
    }
    if (global.DraftOrdersCache) {
      if (typeof global.DraftOrdersCache.invalidate === 'function') {
        global.DraftOrdersCache.invalidate();
      } else if (typeof global.DraftOrdersCache.clearAllCache === 'function') {
        global.DraftOrdersCache.clearAllCache();
      }
    }
  }

  function isLogoutNavigationTarget(target) {
    if (!target) return false;
    var link = target.closest ? target.closest('a[href*="logout"]') : null;
    if (link) return true;
    var form = target.closest ? target.closest('form[action*="logout"]') : null;
    return !!form;
  }

  function bindLogoutClear() {
    document.addEventListener(
      'click',
      function (event) {
        if (!isLogoutNavigationTarget(event.target)) return;
        clearCommercialSession();
      },
      true
    );
    document.addEventListener(
      'submit',
      function (event) {
        if (!isLogoutNavigationTarget(event.target)) return;
        clearCommercialSession();
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindLogoutClear);
  } else {
    bindLogoutClear();
  }

  global.B2BSessionStorage = {
    COMMERCIAL_KEYS: COMMERCIAL_KEYS,
    DRAFT_ORDER_KEYS: DRAFT_ORDER_KEYS,
    DRAFT_ORDER_ID_KEYS: DRAFT_ORDER_ID_KEYS,
    ORDER_WORKFLOW_KEYS: ORDER_WORKFLOW_KEYS,
    CACHE_PREFIXES: CACHE_PREFIXES,
    clearCommercialSession: clearCommercialSession,
    clearDraftOrderContext: clearDraftOrderContext,
    clearDraftOrderIdKeys: clearDraftOrderIdKeys,
    clearOrderWorkflowSession: clearOrderWorkflowSession,
    clearCartNoteRecovered: clearCartNoteRecovered,
    clearCartNoteFields: clearCartNoteFields,
    onCartCleared: onCartCleared,
    stripEncodedNoteSegments: stripEncodedNoteSegments,
    setCartNoteRecovered: setCartNoteRecovered,
  };
})(window);
